import { useEffect } from "react";
import { projectsApi, usersApi, configApi } from "@/api";
import { useRefStore } from "@/stores/uiStore";

/** Loads reference data once after login; exposes reload(). */
export const useRefData = () => {
  const setRef = useRefStore((s) => s.setRef);
  const loaded = useRefStore((s) => s.loaded);
  const reload = async () => {
    const [projectTypes, users, tags, flagTypes, customFields] = await Promise.all([
      projectsApi.types(), usersApi.list(), configApi.tags(), configApi.flagTypes(), configApi.customFields()]);
    setRef({ projectTypes, users, tags, flagTypes, customFields });
  };
  useEffect(() => { if (!loaded) reload().catch(() => {}); }, [loaded]);
  return { reload };
};
